import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

const FT = {
  fr: {
    tagline: "Le savoir des pierres précieuses, au bout des doigts.",
    contact: "Contact",
    legal: "Informations légales",
    privacy: "Politique de confidentialité",
    terms: "Conditions générales",
    labs: "Laboratoires",
    formation: "Formation",
    treatments: "Traitements",
    synthetics: "Synthétiques",
    journal: "Journal",
    about: "À propos",
    explore: "Explorer",
    rights: "Tous droits réservés.",
  },
  en: {
    tagline: "The knowledge of precious stones, at your fingertips.",
    contact: "Contact",
    legal: "Legal information",
    privacy: "Privacy policy",
    terms: "Terms & conditions",
    labs: "Laboratories",
    formation: "Formation",
    treatments: "Treatments",
    synthetics: "Synthetics",
    journal: "Journal",
    about: "About",
    explore: "Explore",
    rights: "All rights reserved.",
  },
};

export const Footer = () => {
  const { lang } = useLang();
  const f = FT[lang];
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="mt-auto border-t border-[#C1A661]/15 bg-[#040711] px-6 md:px-14 py-12"
    >
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10 text-[#A1A7B3]">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-3">
            <img
              src="/brand/gemprice-icon-64.png"
              alt="GEM PRICE"
              width="24"
              height="24"
              className="shrink-0"
            />
            <span className="font-serif text-xl tracking-[0.18em] text-[#E2CFA4]">GEM PRICE</span>
          </div>
          <p className="text-sm max-w-md font-light leading-relaxed text-[#8A8F99]">{f.tagline}</p>
          <div className="mt-5 text-[11px] tracking-[0.2em] uppercase text-[#C1A661]">{f.contact}</div>
          <a
            href="mailto:gemprice@gemprice.org"
            data-testid="footer-contact-email"
            className="text-sm text-[#E2CFA4] hover:text-[#C1A661] transition-colors"
          >
            gemprice@gemprice.org
          </a>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#C1A661] mb-4">{f.explore}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/labs" className="hover:text-[#E2CFA4]">{f.labs}</Link></li>
            <li><Link to="/formation" className="hover:text-[#E2CFA4]">{f.formation}</Link></li>
            <li><Link to="/treatments" className="hover:text-[#E2CFA4]">{f.treatments}</Link></li>
            <li><Link to="/synthetics" className="hover:text-[#E2CFA4]">{f.synthetics}</Link></li>
            <li><Link to="/journal" className="hover:text-[#E2CFA4]">{f.journal}</Link></li>
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-[#E2CFA4]">{f.about}</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-[11px] tracking-[0.25em] uppercase text-[#C1A661] mb-4">{f.legal}</div>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[#E2CFA4]">
                {f.privacy}
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#E2CFA4]">
                {f.terms}
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-[#C1A661]/10 flex flex-col md:flex-row justify-between items-center gap-2 text-[10px] tracking-[0.3em] uppercase text-[#8A8F99]/70">
        <div>© {year} GEM PRICE — {f.rights}</div>
        <div>gemprice.org</div>
      </div>
    </footer>
  );
};

export default Footer;
